export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-user-star-line',
      title: 'Professional Cleaning Experts',
      description: 'Highly trained and experienced cleaning professionals dedicated to delivering exceptional cleaning services Oman across Muscat, Seeb, and Barka'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Reliable Cleaning Company',
      description: 'Consistent, punctual cleaning service you can count on every time. Trusted cleaning company Oman for residential and commercial properties'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly Products',
      description: 'Safe, environmentally conscious cleaning products for your family. Professional cleaning services Oman using green solutions'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Customized Cleaning Solutions',
      description: 'Tailored house cleaning Oman and office cleaning services designed to meet your specific needs across all property types'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Affordable Cleaning Services',
      description: 'Competitive pricing without compromising quality. Best value cleaning services Oman for homes and businesses in Muscat'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'Satisfaction Guaranteed',
      description: '100% satisfaction guarantee on all cleaning services. Leading cleaning company in Oman ensuring you love the results'
    }
  ];

  return (
    <div id="why-choose-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-yellow-600 font-semibold text-sm uppercase tracking-wider">Why Choose Our Cleaning Company</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-3 mb-4">
            What Makes <span className="text-yellow-500">Cleaning Bees</span> the <strong>Best Cleaning Company Oman</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Experience the difference with Oman's most trusted <strong>professional cleaning services</strong> provider serving Muscat, Seeb, Barka, Mabela, Al Hail, Sohar &amp; Salalah
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-yellow-50 to-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-yellow-100"
            >
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className={`${feature.icon} text-3xl text-black`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-2xl p-12 text-center shadow-2xl">
          <h3 className="text-3xl font-bold text-black mb-4">
            Ready to Experience Professional Cleaning Services Oman?
          </h3>
          <p className="text-gray-800 text-lg mb-8 max-w-2xl mx-auto">
            Join thousands of satisfied customers across Oman who trust <strong>Cleaning Bees</strong> for their <strong>house cleaning</strong>, <strong>office cleaning</strong>, and <strong>deep cleaning</strong> needs in Muscat, Seeb, Barka &amp; beyond
          </p>
          <a
            href={`https://wa.me/+96871989006?text=${encodeURIComponent('Hello Cleaning Bees, I would like to learn more about your cleaning services in Oman.')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-3 bg-black text-yellow-400 px-8 py-4 rounded-lg hover:bg-gray-900 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap cursor-pointer font-semibold"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            <span>Get Started Today</span>
          </a>
        </div>
      </div>
    </div>
  );
}